<template>
    <section class="kv" v-lazy:background-image="imgUrl">
      <div class="container">
        <div class="logo" data-aos="fade-right">
          <img class="upper" src="@/assets/img/logo.png" alt="">
          <mainCopy class="under" />
        </div>
        <cups class="cups" />
        <img class="bottle" src="@/assets/img/bottle.png" alt="Bombay Sapphire" 
        data-aos="bottle-right">
        <div class="title-box" data-aos="fade-right" data-aos-offset="-500" data-aos-delay="400">
          <h1>
            <Title alt="SPICE MEETS BOMBAYY SAPPHIRE"/>
            <Title class="shadow" />
            <Title class="shadow" />
          </h1>
          <!--<h1 class="shadow">
            SPICE<br>
            MEETS<br>
            BOMBAY<br>
            SAPPHIRE
          </h1>-->
        </div>
      </div>
    </section>
</template>

<script>
import cups from '@/components/kv/cup.vue'
import mainCopy from '@/assets/img/maincopy.svg?inline'
import Bg from '@/assets/img/kv_pc.jpg'
import Sp from '@/assets/img/kv_sp.jpg'
import Title from '@/assets/img/title_word.svg?inline'

import { vueWindowSize } from 'vue-window-size';
 
vueWindowSize.init();

export default {
    name: 'kv',
    components:{
      cups,
      mainCopy,
      Title
    },
    data(){
        return{
            imgUrl: String
        }
    },
    created(){
      window.addEventListener('resize', this.resized);
    },
    methods:{
        resized(e){
            vueWindowSize.init();
            this.bgChange()
        },
        bgChange(){
            if(this.windowWidth < 980){
                this.imgUrl = Sp
            }
            if(this.windowWidth >= 980){
                this.imgUrl = Bg
            }
        }
    },
    mounted(){
      this.bgChange()
    }
}
</script>

<style lang="scss" scoped>
  .kv{
    width: 100vw;
    height: 100vh;
    min-height: 480px;
    position: relative;
    @extend %flex;
    background-color: $gradient;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: right bottom;
    background-color: #000;
    @extend %lazy;
    min-height: 800px;
    max-height: 1200px;

    @media #{$maxL}{
      background-position: center bottom;
      min-height: calc(100vw * 1.9777);
    }
      .container{
        align-items: flex-end;
      }
      .logo{
        @extend %flex;
        position: absolute;
        top: 15%;
        left: 8%;
        width: 28%;
        min-width: 360px;
        img{
          @media #{$IE}{
            height: 100%;
          }
        }
        @media #{$maxM}{
          min-width: 0;
          width: 60%;
          top: 72px;
          left: 20px;
        }
        .upper{
          width: 80%;
        }
        .under{
          .white{
            fill: #fff;
          }
          .blue{
            fill: #00a9d3;
          }
        }
      }
      .cups{
        width: 32.4%;
        height: auto;
        max-width: 480px;
        position: absolute;
        left: 5%;
        top: 44%;
        display: block;
        min-width: 320px;
        @media #{$maxL}{
          top: 30%;
          left: 20px;
          width: 60%;
          min-width: 0;
          max-width: unset;
        }
        
      }
      .bottle{
        position: absolute;
        width: auto;
        height: 80%;
        max-height: 62vw;
        min-height: 580px;
        right: calc(48% - 4vw);
        bottom: 5%;
        //transform: rotate(6.48deg);
        @media only screen and (max-width: 1180px){
          max-height: 70%;
          min-height: 380px;
        }
        @media #{$maxL}{
          max-height: none;
          min-height: 0;
          width: 50%;
          height: auto;
          right: -8%;
          bottom: unset;
          top: 96px;
        }
      }
      .title-box{
        width: calc(50% - 112px);
        position: absolute;
        top: 50%;
        right: 56px;
        @extend %flex;
        justify-content: center;
        align-items: flex-start;
        @media #{$minMax}{
          right: 0;
        }
        @media #{$maxL}{
          position: absolute;
          width: 58%;
          left: 20px;
          right: unset;
          top: unset;
          bottom: 15%;
          //@media (min-height: 796px){
           // width: 65%;
          //}
        }
        h1{
          display: flex;
          flex-flow: column;
          justify-content: center;
          align-items: center;
          width: 100%;
          height: 50vh;
          min-height: 30vw;
          position: relative;
          margin: 0;
          transform: translateY(-50%);
          @media #{$maxL}{
            height: auto;
            transform: translateY(0%);
            @media #{$IE}{
              height: 100%;
            }
          }
          svg{
            position: relative;
            width: 100%;
            height: auto;
            fill: #fff;
            z-index: 2;
            top: 0;
            left: 0;
            &.shadow{
              position: absolute;
              height: auto;
              width: 100%;
              max-height: 100%;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%);
              transform-origin: center;
              $offset: 0;//0.03em;
              fill: #000;
              filter: blur(5px);
              z-index: 1;
              pointer-events: none;
              @supports not (filter: blur(5px)){
                  opacity: 0;
              }
            }
          }
        }
      }
  }
</style>